import {Container, Col, Row }from 'react-bootstrap';

import Header from '../sections/header';
import Footer from '../sections/footer';
import MainContent from '../sections/maincontent';
import ImageLinkBlock from '../gridspaces/LinkCard';


function PageMedia(){
    return (
        <> 
            <Header />
            <Container fluid className="color-bg-secondary">
                <MainContent>
                    <Row>
                        <Col md className="fill-container py-4">
                            <ImageLinkBlock image='/assets/thumbnails/mambothumbnail.jpg' title='Let them Cook' subtitle='The Road to Mambo Miles' text='' url='https://www.instagram.com/reel/DbQ0c-8RgUg/' type='post'/>
                        </Col>
                        <Col md className="fill-container py-4">
                            <ImageLinkBlock image='/assets/pattythumb.jpg' title='Catching up w/ Tricia Terry' subtitle='Part 1' text='' url='https://www.youtube.com/watch?v=sQlZmmsXCgg' type='video'/>
                        </Col>
                        <Col md className="fill-container py-4">
                            <ImageLinkBlock image='/assets/pattythumb.jpg' title='Catching up w/ Tricia Terry' subtitle='Part 2' text='' url='https://www.youtube.com/watch?v=MpLr8BTCpbk' type='video' />
                        </Col>
                        
                    </Row>
                    <Row>
                        <Col md className="fill-container py-4">
                            <ImageLinkBlock image='/assets/hopkinsthumb.jpg' title='Chicago Marathon Plan 2' subtitle='Featuring Allison "Hops" Hopkins' text='' url='https://www.youtube.com/watch?v=CPq1Lj7gjmc'type='video' />
                        </Col>
                        <Col md className="fill-container py-4">
                            <ImageLinkBlock image='/assets/mannythumb.jpg' title='Chicago Marathon Thoughts w/ Manny' subtitle='Featuring Manny Lopez' text='' url='https://www.youtube.com/watch?v=_F159GsQfXo' type='video' />
                        </Col>
                        <Col md className="fill-container py-4">
                            <ImageLinkBlock image='/assets/wdsthumb.jpg' title='Learning Youtube..' subtitle='Youtube Pilot & Exploration' text='' url='https://www.youtube.com/watch?v=qIl_AimUsIc' type='video' />
                        </Col>
                    </Row>
                </MainContent>
            </Container>
            <Footer />
        </>
    )
}

export default PageMedia;